<script>


export default {
  methods: {
    isLetter: function (e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[A-Za-zА-Яа-я ]+$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    }
  }
}
</script>